<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>

      <el-main>
        <!-- 搜索区折叠按钮 -->
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>

        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">站点</span>
                <el-select  v-model="tableParam.stationName"  placeholder="请选择站点"  clearable  filterable  style="width: 180px"  >
                  <el-option  v-for="item in siteOptions"  :key="item.value"  :label="item.label"  :value="item.value"/>
                </el-select>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">任务日期</span>
                <el-date-picker
                  v-model="tableParam.createTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px"
                />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">状态</span>
                <el-select  v-model="tableParam.taskStatus"  placeholder="请选择状态"  clearable  style="width: 140px" >
                  <el-option label="进行中" :value="1" />
                  <el-option label="已完成" :value="2" />
                  <el-option label="已失效" :value="3" />
                </el-select>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="handleSearch">查询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="resetSearch">重置</el-button>
            </div>
          </div>
        </el-collapse-transition>

        <div class="hr"></div>

        <div class="card">
          <div class="card_nav">
            <div></div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in tableColumns" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link :underline="false" @click="download()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>
                导出
              </el-link>
            </div>
          </div>

          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table  :header-cell-style="{ background: '#f3f6f9' }"  :cell-style="{ borderRight: 'none' }"  border  stripe  style="width: 100%"  :data="tableData"  tooltip-effect="dark">
              <template v-for="(item, index) in visibleColumns">
                <el-table-column  :key="index"  :label="item.label"  :prop="item.prop"  :width="item.width"  :fixed="item.label === '操作' ? 'right' : false"  align="center">
                  <template slot-scope="scope">
                    <!-- 巡检日志列 -->
                    <span v-if="item.prop === 'inspectionStatus'">
                      <span v-if="scope.row.inspectionStatus === 0" style="color: #909399">未填写</span>
                      <el-button  v-else-if="scope.row.inspectionStatus === 1"  type="text"  size="small"  @click="viewLogDetail(scope.row)">查看</el-button>
                      <span v-else>--</span>
                    </span>
                    <!-- 状态列 -->
                    <span v-else-if="item.prop === 'taskStatus'">
                      <el-tag v-if="scope.row.taskStatus === 1" type="info" size="small">进行中</el-tag>
                      <el-tag v-else-if="scope.row.taskStatus === 2" type="success" size="small">已完成</el-tag>
                      <el-tag v-else-if="scope.row.taskStatus === 3" type="danger" size="small">已失效</el-tag>
                      <span v-else>--</span>
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>

      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共 {{ total }} 条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="handlePageChange"
          />
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="refreshData">刷新</el-button>
        </div>
      </div>
    </el-container>

    <!-- 巡检日志详情弹窗 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="logDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      @close="closeLogDialog"
    >
      <span slot="title" class="dialog-title">巡检日志详情</span>
      <div v-if="currentLogDetail">
        <!-- 任务站点和任务时间显示 -->
        <div class="log-info">
          <div class="info-item"><span class="info-label">任务站点：</span>{{ currentLogDetail.stationName }}</div>
          <div class="info-item"><span class="info-label">任务时间：</span>{{ currentLogDetail.taskDate }}</div>
        </div>
        <!-- 材料表格子组件 -->
        <div v-loading="logLoading">
          <log-material-table :data="currentLogDetail.materials" />
        </div>
      </div>
      <div v-else v-loading="logLoading" style="min-height: 200px"></div>

      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="logDialogVisible = false">取消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="logDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from '@/mixins/ICPSmixin.js'
import { queryInspection, queryResord } from '@/api/basicConfig/binInspection.js'
import { getUserAutList } from '@/api/common.js'
import LogMaterialTable from './components/LogMaterialTable.vue'

export default {
  name: 'InspectionTaskList',
  components: { LogMaterialTable },
  mixins: [mixin],
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false,
      style: {},
      showCardNav: true,
      taskDate: '',
      tableParam: {
        page: 1,
        pageSize: 10,
        stationName: '',
        createTime: '',
        taskStatus: 1,
      },
      siteOptions: [],
      tableColumns: [
        { label: '任务日期', width: 'auto', prop: 'createTime', status: true },
        { label: '站点', width: 'auto', prop: 'stationName', status: true },
        { label: '巡检日志', width: 'auto', prop: 'inspectionStatus', status: true },
        { label: '状态', width: 'auto', prop: 'taskStatus', status: true },
      ],
      logDialogVisible: false,
      logLoading: false,
      currentLogDetail: null,  // 包含 stationName, taskDate, materials
    }
  },
  computed: {
    visibleColumns() {
      return this.tableColumns.filter(col => col.status)
    }
  },
  created() {
    this.getSiteList()
    this.getTableData()
  },
  methods: {
    getSiteList() {
      getUserAutList(true)
        .then(res => {
          let stations = []
          if (res && res.data && Array.isArray(res.data)) {
            stations = res.data
          } else if (Array.isArray(res)) {
            stations = res
          }
          this.siteOptions = stations.map(item => ({
            label: item.name,
            value: item.name,
          }))
        })
        .catch(err => {
          this.$message.error('获取站点列表失败：' + (err.message || '网络错误'))
        })
    },
    getTableData() {
      this.tableLoading = true
      const params = {
        page: this.tableParam.page,
        pageSize: this.tableParam.pageSize,
        stationName: this.tableParam.stationName,
        createTime: this.tableParam.createTime,
        taskStatus: this.tableParam.taskStatus,
      }
      queryInspection(params)
        .then(res => {
          if (res && res.code === 1001) {
            this.tableData = res.data?.data || []
            this.total = res.data?.totalRows || 0
          } else {
            this.$message.error(res?.codeMsg || '获取数据失败')
          }
        })
        .catch(err => {
          this.$message.error('查询失败：' + (err.message || '网络错误'))
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    handleSearch() {
      this.tableParam.page = 1
      this.getTableData()
    },
    resetSearch() {
      this.tableParam.stationName = ''
      this.taskDate = ''
      this.tableParam.createTime = ''
      this.tableParam.taskStatus = 1
      this.tableParam.page = 1
      this.getTableData()
    },
    sizeChange(value) {
      this.tableParam.pageSize = value
      this.getTableData()
    },
    handlePageChange() {
      this.getTableData()
    },
    download() { 
      console.log('download')
    },  
    refreshData() {
      this.getTableData()
    },
    // 查看巡检日志详情（打开弹窗）
    viewLogDetail(row) {
      if (row.inspectionStatus !== 1) {
        this.$message.warning('当前巡检日志未填写')
        return
      }
      this.logDialogVisible = true
      this.logLoading = true
      this.currentLogDetail = null

      // 调用接口获取材料数组
      queryResord({ id: row.id })
        .then(res => {
          if (res && res.code === 1001) {
            // 直接使用接口返回的数组作为 materials
            this.currentLogDetail = {
              stationName: row.stationName,   // 从当前行取站点
              taskDate: row.createTime,       // 从当前行取任务日期
              materials: res.data || []       // 接口返回的材料数组
            }
          } else {
            this.$message.error(res?.codeMsg || '获取日志详情失败')
            this.logDialogVisible = false
          }
        })
        .catch(err => {
          this.$message.error('获取日志详情失败：' + (err.message || '网络错误'))
          this.logDialogVisible = false
        })
        .finally(() => {
          this.logLoading = false
        })
    },
    closeLogDialog() {
      this.currentLogDetail = null
    },
    handleView(row) {
      this.$router.push({ name: 'inspectionTaskDetail', query: { id: row.id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.header_right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  .title {
    font-size: 14px;
    font-weight: 500;
    color: #606266;
  }
}
.arrowTransform {
  transform: rotate(180deg);
  transition: all 0.3s;
}
.arrowTransformReturn {
  transform: rotate(0deg);
  transition: all 0.3s;
}
.search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
}
.hr {
  height: 1px;
  background: #ebeef5;
  margin: 16px 0;
}
.card_nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.card_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  .card_bottom_left {
    display: flex;
    align-items: center;
    .top_page_totle {
      margin-right: 16px;
      font-size: 14px;
      color: #606266;
    }
  }
}
.log-info {
  display: flex;
  margin-bottom: 20px;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  .info-item {
    margin-right: 30px;
    font-size: 14px;
    .info-label {
      font-weight: 500;
      color: #606266;
    }
  }
}
</style>